(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page-parallax"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const parallax = document.querySelector(".parallax-section .parallax-image");

  function updateParallax() {
    let scrolled = window.pageYOffset;
    let sectionTop = parallax.parentElement.offsetTop;
    let sectionHeight = parallax.parentElement.offsetHeight;
    let windowHeight = window.innerHeight;

    // only run while section is in view
    if (scrolled + windowHeight > sectionTop && scrolled < sectionTop + sectionHeight) {
      let yOffset = (scrolled - sectionTop) * 0.4; // parallax speed
      parallax.style.transform = `translateY(${yOffset}px)`;
    }
    requestAnimationFrame(updateParallax);
  }

  requestAnimationFrame(updateParallax);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobl-native-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = () => {
    const bar = document.querySelector('.nobl-weekender-black');
    const cart = document.querySelector('#cart-icon-bubble');
    if (!bar || !cart) return;
    const align = () => {
      const cartBox = cart.getBoundingClientRect();
      const barBox = bar.getBoundingClientRect();
      if (barBox.width && cartBox.width) bar.style.setProperty('--wk-cart-right', Math.max(20, barBox.right - cartBox.right) + 'px');
    };
    const resize = new ResizeObserver(align);
    resize.observe(cart);
    resize.observe(bar);
    const changes = new MutationObserver(align);
    changes.observe(cart, {childList:true, subtree:true});
    window.addEventListener('resize', align, {passive:true});
    align();
    document.fonts.ready.then(align);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nobl-weekender-black-bar"] && !Shopify.designMode) return;
  try {
    
(() => {
  const mount = () => {
    const bar = document.querySelector('.nobl-weekender-black');
    const cart = document.querySelector('#cart-icon-bubble');
    if (!bar || !cart) return;
    const align = () => {
      const cartBox = cart.getBoundingClientRect();
      const barBox = bar.getBoundingClientRect();
      if (barBox.width && cartBox.width) bar.style.setProperty('--wk-cart-right', Math.max(20, barBox.right - cartBox.right) + 'px');
    };
    const resize = new ResizeObserver(align);
    resize.observe(cart);
    resize.observe(bar);
    const changes = new MutationObserver(align);
    changes.observe(cart, {childList:true, subtree:true});
    window.addEventListener('resize', align, {passive:true});
    align();
    document.fonts.ready.then(align);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
})();

  } catch(e) { console.error(e); }
})();
})();
